import React, { Component } from 'react';
import TaggedImage from './../taggedImage';
import { withController, Parallax } from 'react-scroll-parallax';
import "./lookBookCenteredImage.css";

class LookBookCenteredImage extends Component {
  imageLoaded = () =>{
    this.props.parallaxController.update();
  }
  render() {
    return(
      <div className="lookbook-centered-image-photo-container full-width centered-text">
        <div className="lookbook-centered-image-photo" style={{margin:'auto'}}>
          {this.props.image &&
              <div
                className={"full-width"}
              >
                <Parallax y={[-10, 0]}>
                  {this.props.latlng ?
                    <TaggedImage
                      image={this.props.image}
                      backgroundImage={this.props.backgroundImage}
                      latlng={this.props.latlng}
                      city={this.props.city}
                    />
                  :
                    <img className="full-width"
                      onLoad={this.imageLoaded}
                      src={this.props.image}
                      backgroundImage={this.props.backgroundImage}
                    />
                  }
                </Parallax>
              </div>
            }
        </div>
      </div>
    )
  }
}

export default withController(LookBookCenteredImage);



// WEBPACK FOOTER //
// ./src/components/lookBookCenteredImage/index.js